import React, { useEffect } from 'react';
import { VideoIframe } from './VideoIframe';
import ConditionalToggling from 'utilities/toggling/ConditionalToggling/ConditionalToggling';
import { i18n } from 'core/i18n';
import { connect } from 'react-redux';
import { videoReset } from 'actions/video';
import { getStatusCode } from 'utilities/video/status/getStatusCode';
import {
    ABORTED,
    BLOCKED,
    CALLCENTER_KO,
    COMPLETED,
    CONNECT_ERROR,
    DEFINITE_KO,
    ERROR,
    EXPIRED_DOCUMENT,
    LOW_QUALITY,
    NON_EXCLUSIVE,
    WAITING,
    WRONG_FACE_MATCH,
    WRONG_PERMISSIONS,
} from 'constants/video/status';
import { PATH_IDENTITY } from 'constants/uTagConstants/paths';
const { formatText } = i18n;
import { hidePreLoader, setInformationText, showPreLoader } from 'actions/preLoaderActions';
import cryptoJS from 'crypto-js';
import { VIDEO_CALL, VIDEO_SELFIE } from 'constants/identityMethod';
import { clientDefiniteKO } from 'actions/identityValidationActions';
import { get } from 'utilities/APIRequestHelper';
import {
    recordEvent,
    RELIABLE,
    PAGE_PRODUCT,
    VIDEOCALL_IDENTIFICATION,
    VIDEOSELFIE_IDENTIFICATION,
} from 'utilities/uTagging';
import { CUSTOM_MODAL_ERRORS } from '../../constant';
import { usePollingContext } from 'components/newIdentifyMethods/VideoScreen/contexts/PollingContext';

const VideoOld = ({
    userProfile,
    isVideoCallType,
    identityType,
    videoUrl,
    handleModal,
    clientDefiniteKO,
    showPreLoader,
    hidePreLoader,
    setInformationText,
    videoReset,
    onFinishVideoSelfie,
}) => {
    const { startPolling, stopPolling } = usePollingContext();

    const setVideoTypeRecordConsts = type => {
        const VIDEOS_TYPE = {
            [VIDEO_CALL]: 'videollamada',
            [VIDEO_SELFIE]: 'videoselfie',
        };

        return {
            callCenterKO: `validacion por ${VIDEOS_TYPE[type]} call center`,
            definiteKO: `validacion por ${VIDEOS_TYPE[type]} KO definitivo`,
            aborted: `validacion por ${VIDEOS_TYPE[type]} KO definitivo`,
            completed: `validacion por ${VIDEOS_TYPE[type]} correcto`,
            nonExclusive: `validacion por ${VIDEOS_TYPE[type]} KO NO definitivo`,
            blocked: `validacion por ${VIDEOS_TYPE[type]} video llamada bloqueada`,
            expiredDocument: `validacion por ${VIDEOS_TYPE[type]} documento expirado (24)`,
            loqQuality: `validacion por ${VIDEOS_TYPE[type]} baja calidad (20)`,
        };
    };

    const handleInProgress = body => {
        const { status, method } = body;
        const statusCode = getStatusCode(status, method, userProfile);
        switch (statusCode) {
            case NON_EXCLUSIVE:
            case BLOCKED:
            case LOW_QUALITY:
            case CONNECT_ERROR:
            case EXPIRED_DOCUMENT:
            case WRONG_FACE_MATCH:
            case WRONG_PERMISSIONS:
                hidePreLoader();

                return false;
            case ABORTED:
            case CALLCENTER_KO:
            case COMPLETED:
            case DEFINITE_KO:
                hidePreLoader();

                return false;
            case WAITING:
                showPreLoader();
                setInformationText(formatText('identity-videoCallSpinner'));

                return true;
            default:
                return true;
        }
    };
    const handleVideo = response => {
        if (!response) return true;
        const { ok, body } = response;
        if (ok && body) {
            return handleInProgress(body);
        }

        return true;
    };
    const recordEventVideo = result => {
        const { docNumber, recordId, userId, investmentType } = userProfile;
        const docNumberEncrypted = docNumber ? cryptoJS.SHA256(docNumber).toString() : '';

        const VIDEO_TYPES_TAGGING_PATHS = {
            [VIDEO_CALL]: VIDEOCALL_IDENTIFICATION,
            [VIDEO_SELFIE]: VIDEOSELFIE_IDENTIFICATION,
        };

        const VIDEO_RELIABLES = {
            [VIDEO_CALL]: RELIABLE['videoCall'],
            [VIDEO_SELFIE]: RELIABLE['videoSelfie'],
        };

        const videoTypeResultsTag = setVideoTypeRecordConsts(identityType);

        recordEvent(
            PATH_IDENTITY,
            PAGE_PRODUCT,
            VIDEO_TYPES_TAGGING_PATHS[identityType],
            videoTypeResultsTag[result],
            recordId,
            userId,
            VIDEO_RELIABLES[identityType],
            investmentType,
            docNumberEncrypted
        );
    };

    const handleFinish = (response, stats) => {
        const { ok, error } = stats;

        if (ok) {
            const {
                body: { status, onboardingStatus, method },
            } = response;

            const statusCode = getStatusCode(status, method, userProfile);
            statusCode !== WAITING && recordEventVideo(statusCode);

            if (CUSTOM_MODAL_ERRORS.includes(statusCode)) {
                handleModal(true, statusCode, status);

                return;
            }

            if ([DEFINITE_KO, ABORTED].includes(statusCode)) {
                clientDefiniteKO();

                return;
            }

            if (statusCode !== ERROR) {
                onFinishVideoSelfie({ statusCode, onboardingStatus });
            }
        }

        if (error) {
            hidePreLoader();
            handleModal(true, ERROR);
        }
    };
    useEffect(() => {
        startPolling({
            asyncFetch: () => get('getClientIdentificationStatus'),
            callback: handleVideo,
            callbackEnd: handleFinish,
            delay: 1,
            retryOnFailure: true,
            retryAfter: 3,
            stopAfterRetries: 2,
        });
        window.scrollTo(0, 0);

        return () => {
            videoReset();
            stopPolling();
        };
    }, []);

    return (
        <div className={isVideoCallType ? 'videoCall-container' : 'videoSelfie-container'}>
            <div className={isVideoCallType ? 'videoCall-frame' : 'videoSelfie-frame'}>
                <VideoIframe type={identityType} videoUrl={videoUrl} />
            </div>
            <ConditionalToggling condition={isVideoCallType}>
                <div className="video-info">
                    <header>
                        <h4 className="font-heading6">{formatText('identity-videoScreenTitle')}</h4>
                    </header>
                    <span className="dash" />
                    <ol className="detailsContainer">
                        <li className="font-paragraph2">{formatText('identity-videoScreenPresentation')}</li>
                        <li className="font-paragraph2">{formatText('identity-videoScreenquestions')}</li>
                        <li className="font-paragraph2">{formatText('identity-videoScreenDiagnosis')}</li>
                    </ol>
                </div>
            </ConditionalToggling>
        </div>
    );
};
const mapDispatchToProps = {
    showPreLoader,
    setInformationText,
    hidePreLoader,
    clientDefiniteKO,
    videoReset,
};

export default connect(null, mapDispatchToProps)(VideoOld);
